import { useEffect, useRef } from 'react';
import { styled } from '../styled';

const Wrap = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

const Input = styled('input')({
  width: '100%',
  height: 40,
  padding: '0 36px 0 36px',
  border: '1px solid var(--qhs-border)',
  borderRadius: 8,
  background: 'var(--qhs-surface)',
  color: 'var(--qhs-text-1)',
  fontSize: 13,
  outline: 'none',
  transition: 'border-color 160ms ease, box-shadow 160ms ease',
  '&:focus': {
    borderColor: 'var(--qhs-brand)',
    boxShadow: '0 0 0 3px var(--qhs-focus-ring)',
  },
  '&::placeholder': { color: 'var(--qhs-text-3)' },
});

const SearchIcon = styled('span')({
  position: 'absolute',
  left: 12,
  color: 'var(--qhs-text-3)',
  '& svg': { width: 14, height: 14 },
});

const ClearBtn = styled('button')({
  position: 'absolute',
  right: 8,
  appearance: 'none',
  border: 'none',
  background: 'transparent',
  color: 'var(--qhs-text-3)',
  width: 22,
  height: 22,
  borderRadius: 4,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': { background: 'var(--qhs-surface-hover, #f0f4f9)', color: 'var(--qhs-text-1)' },
  '& svg': { width: 12, height: 12 },
});

const SearchSvg = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const XSvg = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const CatalogSearch = ({ value, onChange, placeholder, autoFocus, onClear }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (autoFocus) ref.current?.focus();
  }, [autoFocus]);

  return (
    <Wrap>
      <SearchIcon>
        <SearchSvg />
      </SearchIcon>
      <Input
        ref={ref}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <ClearBtn type="button" onClick={onClear} aria-label="Clear">
          <XSvg />
        </ClearBtn>
      )}
    </Wrap>
  );
};

export default CatalogSearch;
